import tw, { styled } from 'twin.macro';
import AnnouncementButton from '@/components/AnnouncementButton/AnnouncementButton';
import { Container } from '@/components/AnnouncementButton/AnnouncementButton.styles';

export const StyledAnnouncementButton = styled(AnnouncementButton)`
  ${tw`col-span-12`}

  &, ${Container} {
    ${tw`py-0!`}
  }
`;
